import React, { Component } from 'react';

import { RepeaterAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { array, arrayOf, element, object, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { propagateData } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.BEHAVIOR, api: RepeaterAPI })
class Repeater extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: arrayOf(oneOfType([object, array])).notEnumerable(),
    uuid: string,
  };

  static defaultProps = {
    data: [],
  };

  render() {
    const { data, children, uuid } = this.props;

    const Container = ContainerProvider.provide(this);

    if (React.Children.count(children) === 0) {
      return <Container className="u-expand" uuid={uuid} repeated />;
    }

    return Array.isArray(data)
      ? data.map((item) => propagateData(children, item, {}, true))
      : null;
  }
}

export default Repeater;
